
import React from "react";
import PartRating from "@/components/PartRating";
import { ColumnId, SortState } from "../PartTableHeader";

interface RatingCellProps {
  rating: number;
  sortState: SortState;
  columnId: ColumnId;
}

const RatingCell = ({ rating }: RatingCellProps) => {
  return (
    <div className="flex items-center">
      <PartRating rating={rating} />
    </div>
  );
};

export default RatingCell;
